(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("talentPoolDataService", TalentPoolDataService);

    TalentPoolDataService.$inject = ['$q', 'hUser', 'userPermissions'];

    function TalentPoolDataService($q, hUser, userPermissions) {
        var self = this;
        let brandTalentPoolSettingsCache = {};
        const _emitter = JarEventEmitter.call(self);
        self.filters = {};

        self.getBrandTalentPoolSettings = function (brandId) {
            var deferred = $q.defer();

            if (brandTalentPoolSettingsCache[brandId]) {
                deferred.resolve(brandTalentPoolSettingsCache[brandId]);
            } else {
                TalentPoolAPI2.getBrandTalentPoolSettings(brandId)
                    .then(function (data) {
                        brandTalentPoolSettingsCache[brandId] = data;
                        deferred.resolve(brandTalentPoolSettingsCache[brandId]);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        };

        self.removeCandidatesFromPool = function (brandId, candidateIds) {
            var deferred = $q.defer();

            TalentPoolAPI2.removeCandidatesFromPool(brandId, candidateIds)
                .then(function (res) {
                    deferred.resolve(res);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getCandidateTalentPoolResume = function (groupId, candidateId) {

            var deferred = $q.defer();

            MemberAPI.getCandidateTalentPoolResume(groupId, candidateId)
                .then(function (resume) {
                    deferred.resolve(resume);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.checkTalentPoolPermissionOnEnterpriseAndChild = function () {
            var defer = $q.defer();

            if (['enterprise', 'brand'].indexOf(hUser.getUserContext().brand_type) > -1) {
                var getBrandsPermission = false;
                var brandIds = _.pluck(hUser.data.user.brands_list, 'id');

                userPermissions.getBrandPolicy(brandIds)
                    .then(function (policyParser) {
                        getBrandsPermission = policyParser.brands(policyParser.ANY).hasAny([userPermissions.PERMISSIONS.MANAGE_TALENT_POOL_MODULE]);
                        defer.resolve(getBrandsPermission);
                    }).catch(function (err) {
                    defer.reject(err);
                });
            } else {
                defer.resolve(false);
                console.warn('invalid action in top level context');
            }

            return defer.promise;
        }

        self.resetFiltersData = function () {
            Object.values(self.filters).forEach((filterData) => {
                if (filterData.length) {
                    for (let i = 0; i < filterData.length; i++) {
                        filterData[i].checked = false;
                    }
                }
            });
        };

        self.setFilters = function (filtersData) {
            self.filters = filtersData;
        };

        self.getFilters = function () {
            return self.filters;
        };

        self.triggerSelectTag = (tag) => {
            _emitter.trigger('selected-tags-updated-event', tag);
        };

        self.prepareCandidateSpeedyScreenData = (candidate) => {
            return {
                user_id: candidate.id,
                brand_id: candidate.source_brand.id,
                slug: candidate.slug,
                profile_image_uuid: candidate.profileImageUUID || '',
                first_name: candidate.firstName,
                last_name: candidate.lastName,
                fullName: candidate.fullName,
                email: candidate.email,
                phone: candidate.phone,
            };
        }

        return self;
    }
}());
